<template>
  <!-- eslint-disable vue/no-use-v-if-with-v-for -->
  <div class="game-container">
    <div class="crossword-overflov-container" :style="getStyle(startGameConfig)">
      <div class="overflov-element">
        <table class="crossword">
          <tr v-for="(row, i) in diagram" :key="'row' + i">
            <td :class="[{ null: !isNull(diagram[i][0].correct) }, { num: !isNull(diagram[i][0].correct) }]">
              <span v-if="!isNull(diagram[i][0].correct)">{{ i + 1 }}.</span>
            </td>
            <td
              v-for="(col, j) in row"
              :key="'col' + j"
              :class="[
                { null: isNull(diagram[i][j].correct) },
                { num: isNum(i, j) },
                { answer: isStatic(diagram[i][j]) },
                { pass: isPass(i, j) },
                { answerGood: isGood(diagram[i][j]) },
                { answerBad: isWrong(diagram[i][j]) },
              ]"
              :style="{ 'background-color': isPass(i, j) && diagram[i][j].static && diagram[i][j].static.color }"
            >
              <span v-if="isNum(i, j)">{{ i + 1 }}.</span>
              <div
                v-else-if="isStatic(diagram[i][j])"
                class="answerStatic"
                :style="{ 'background-color': diagram[i][j].static.color }"
                :id="diagram[i][j].id"
              >
                {{ diagram[i][j].correct[0] }}
              </div>
              <tr-input
                v-else-if="!isNull(diagram[i][j].correct)"
                :key="diagram[i][j].id"
                :ref="diagram[i][j].id"
                :config="diagram[i][j]"
                :tr-input-value="diagram[i][j]"
                @key-arrow-left="moveLeft"
                @key-arrow-right="moveRight"
                @key-arrow-up="moveUp"
                @key-arrow-down="moveDown"
                @change-element="autoMove"
                :background-color="'transparent'"
                :max-length="1"
                :input-width="startGameConfig.inputWidth"
              ></tr-input>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="listPasss" :style="getListPasssStyle(startGameConfig.sharedBlock)">
      <div
        v-if="startGameConfig.sharedBlock && startGameConfig.sharedBlock.txt"
        class="list-pass-element-container"
        :style="{
          position: startGameConfig.sharedBlock.pos !== undefined ? 'absolute' : false,
          top:
            startGameConfig.sharedBlock.pos !== undefined && startGameConfig.sharedBlock.pos.y !== undefined
              ? startGameConfig.sharedBlock.pos.y
              : false,
          left:
            startGameConfig.sharedBlock.pos !== undefined && startGameConfig.sharedBlock.pos.x !== undefined
              ? startGameConfig.sharedBlock.pos.x
              : false,
        }"
      >
        <p v-if="startGameConfig.sharedBlock.title !== undefined" v-html="startGameConfig.sharedBlock.title"></p>
        <span
          v-for="(item, i) in shuffle(startGameConfig.sharedBlock.txt, startGameConfig.sharedBlock.shuffle)"
          v-html="item"
          :key="'shared' + i"
        ></span>
      </div>
      <ol class="passList" v-if="!startGameConfig.posAbsolute" :style="getPasssListStyle(startGameConfig.sharedBlock)">
        <p v-if="isTitle(startGameConfig)">{{ startGameConfig.sharedBlock.title }}</p>
        <li v-for="(item, index) in initData" :key="index">
          <span v-if="item.txt !== undefined" v-html="item.txt"></span>
          <img
            v-if="item.src !== undefined"
            :src="item.src"
            :style="{
              width: startGameConfig.imgW !== undefined ? startGameConfig.imgW : 'auto',
              height: startGameConfig.imgH !== undefined ? startGameConfig.imgH : 'auto',
            }"
          />
        </li>
      </ol>
    </div>
    <div
      v-for="(item, index1) in initData"
      :key="index1"
      v-if="startGameConfig.posAbsolute === true && startGameConfig.sharedBlock === undefined"
      :style="{
        position: item.pos !== undefined ? 'absolute' : false,
        top: item.pos !== undefined && item.pos.y !== undefined ? item.pos.y : false,
        left: item.pos !== undefined && item.pos.x !== undefined ? item.pos.x : false,
      }"
    >
      <span v-if="item.txt !== undefined" v-html="item.txt"></span>
      <img
        v-if="item.src !== undefined"
        :src="item.src"
        :style="{
          width: startGameConfig.imgW !== undefined ? startGameConfig.imgW : 'auto',
          height: startGameConfig.imgH !== undefined ? startGameConfig.imgH : 'auto',
        }"
      />
    </div>
  </div>
  <!-- eslint-enable vue/no-use-v-if-with-v-for -->
</template>

<script>
import _ from 'lodash';
import TrInput from '../TrInput/TrInputV2';
import defaultMixin from '../../mixins/defaultMixinV2';
export default {
  name: 'mp-crossword-v2',
  components: { TrInput },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
      diagram: [],
    };
  },
  beforeMount() {
    this.initGame();
  },
  mounted() {},
  methods: {
    shuffle(items, activate) {
      if (items.length == 0) {
        return;
      }
      // for ( let i = a.length - 1; i > 0; i-- ) {
      //   const j = Math.floor( Math.random() * ( i + 1 ) );
      //   [ a[ i ], a[ j ] ] = [ a[ j ], a[ i ] ];
      // }
      return activate ? _.shuffle(items) : items;
    },
    initGame() {
      this.initData = this.startGameConfig.crossword;
      this.diagram = [];
      var self = this;
      var count = 0;
      let wordList;
      this.initData.forEach(function (item, i) {
        if (!_.isArray(item.pass)) {
          item.pass = [item.pass];
        }
        wordList = _.map(item.pass, (password) => {
          return password.split('');
        });
        self.$set(self.diagram, i, []);
        for (let j = 0; j < item.indx; j++) {
          self.$set(self.diagram[i], j, { correct: null });
        }
        if (wordList[0]) {
          for (let j = item.indx; j < wordList[0].length + item.indx; j++) {
            let staticIndex = _.findIndex(item.static, (o) => {
              return o.index == j - item.indx;
            });
            self.$set(self.diagram[i], j, {
              id: i + '-' + j,
              correct: _.map(wordList, (word) => {
                if (word[j - item.indx]) {
                  return word[j - item.indx];
                }
              }),
              wrong: false,
              static:
                item.static !== undefined && staticIndex != -1
                  ? { color: item.static[staticIndex].color || '' }
                  : false,
              val: '',
              block: false,
              inputStatus: null,
            });
          }
        }
        if (self.diagram[i].length > count) count = self.diagram[i].length;
      });
    },
    newGame() {
      for (let i = 0; i < this.diagram.length; i++) {
        for (let j = 0; j < this.diagram[i].length; j++) {
          if (this.diagram[i][j].val != null) {
            this.$set(this.diagram[i][j], 'block', false);
            this.$set(this.diagram[i][j], 'val', '');
            if (this.diagram[i][j].obj) {
              this.diagram[i][j].obj.inputsVal('');
            }
          }
        }
      }
      if (this.password !== undefined) {
        for (let i = 0; i < this.password.length; i++) {
          this.$set(this.password[i], 'block', false);
          this.$set(this.password[i], 'val', '');
          if (this.password[i].obj) {
            this.password[i].obj.inputsVal('');
          }
        }
      }
    },
    isNull(a) {
      return a == null;
    },
    isPass(i, j) {
      let pass = false;
      if (this.initData && this.initData[i] && _.isArray(this.initData[i].sel)) {
        _.each(this.initData[i].sel, (item) => {
          if (this.initData[i].indx + item == j) {
            pass = true;
          }
        });
        return pass;
      }
      return this.initData[i].indx + this.initData[i].sel == j;
    },
    isNum(i, j) {
      return (
        this.diagram[i][j].correct == null &&
        this.diagram[i][j + 1] !== undefined &&
        (this.diagram[i][j + 1].correct !== null || this.isPass(i, j + 1) == true)
      );
    },
    // testChange($event, payload) {
    //   // console.log('testChange', $event);
    //   // console.log('payload', payload);
    // },
    autoMove($event, payload) {
      let focusElement = this.splitIdPosition(payload, 'right');
      let i = 1;
      while (i++ < 12 && this.testNextPossibleCell(focusElement)) {
        focusElement = this.splitIdPosition(payload, 'right', i);
      }
      // if (_.isUndefined(this.$refs[focusElement])) {
      //   // focusElement = this.splitIdPosition(payload);
      //   focusElement = this.splitIdPosition(payload, 'down');
      //   i = 1;
      //   while (i++ < 12 && !this.testNextPossibleCell(focusElement)) {
      //     // focusElement = this.splitIdPosition(payload, 'left', i);
      //     focusElement = this.splitIdPosition(focusElement, 'left', i);
      //   }
      //   // // console.log('el', this.$refs[focusElement]);
      //   // var e = $.Event("keydown");
      //   // e.which = '80';
      //   // e.keyCode = '80';
      //   // // $("input").trigger(e);
      //   // // console.log('test', this.$refs[focusElement][0].$el.querySelector('input'));
      //   // $(this.$refs[focusElement][0].$el.querySelector('input')).trigger('e');
      // }
      this.moveCursor(focusElement);
    },
    moveCursor(focusElement) {
      if (this.$refs[focusElement]) {
        this.$refs[focusElement][0].$el.querySelector('input').select();
      }
    },
    testNextPossibleCell(focusElement) {
      if (_.isString(focusElement)) {
        // // console.log('test', this.$refs[focusElement][0].className);
        if (this.$refs[focusElement] && this.$refs[focusElement][0] && this.$refs[focusElement][0].config) {
          return this.$refs[focusElement][0].config.block;
        } else if (
          this.$refs[focusElement] &&
          this.$refs[focusElement][0] &&
          this.$refs[focusElement][0].className === 'answerStatic'
        ) {
          return true;
        }
        // else if (this.$refs[focusElement] && this.$refs[focusElement][0] && this.$refs[focusElement][0].className === 'null') {
        //   return true;
        // }
      }
      return false;
    },
    splitIdPosition(idString, type = 'current', range = 1) {
      let focusElement = idString.split('-');
      if (focusElement.length === 2) {
        focusElement = _.map(focusElement, (item, index) => {
          switch (type) {
            case 'left':
              if (index === 1) {
                return parseInt(item) - parseInt(range);
              }
              return parseInt(item);
              break;
            case 'right':
              if (index === 1) {
                return parseInt(item) + parseInt(range);
              }
              return parseInt(item);
              break;
            case 'up':
              if (index === 0) {
                return parseInt(item) - parseInt(range);
              }
              return parseInt(item);
              break;
            case 'down':
              if (index === 0) {
                return parseInt(item) + parseInt(range);
              }
              return parseInt(item);
              break;
            case 'current':
              if (index === 0) {
                return parseInt(item);
              }
              return parseInt(item);
              break;
          }
        });
      } else if (focusElement.length === 3) {
        focusElement = _.map(focusElement, (item, index) => {
          switch (type) {
            case 'left':
              if (index === 1) {
                return parseInt(item) - parseInt(range);
              }
              return item;
              break;
            case 'right':
              if (index === 1) {
                return parseInt(item) + parseInt(range);
              }
              return item;
              break;
            case 'up':
              if (index === 0) {
                return parseInt(item) - parseInt(range);
              }
              return item;
              break;
            case 'down':
              if (index === 0) {
                return parseInt(item) + parseInt(range);
              }
              return item;
              break;
          }
        });
      }
      focusElement = focusElement.join('-');
      return focusElement;
    },
    moveLeft(event, payload) {
      let focusElement = this.splitIdPosition(payload, 'left');
      let i = 1;
      while (i++ < 12 && this.testNextPossibleCell(focusElement)) {
        focusElement = this.splitIdPosition(payload, 'left', i);
      }
      this.moveCursor(focusElement);
    },
    moveRight(event, payload) {
      let focusElement = this.splitIdPosition(payload, 'right');
      let i = 1;
      while (i++ < 12 && this.testNextPossibleCell(focusElement)) {
        focusElement = this.splitIdPosition(payload, 'right', i);
      }
      this.moveCursor(focusElement);
    },
    moveUp(event, payload) {
      let focusElement = this.splitIdPosition(payload, 'up');
      let i = 1;
      while (i++ < 12 && this.testNextPossibleCell(focusElement)) {
        focusElement = this.splitIdPosition(payload, 'up', i);
      }
      this.moveCursor(focusElement);
    },
    moveDown(event, payload) {
      let focusElement = this.splitIdPosition(payload, 'down');
      let i = 1;
      while (i++ < 12 && this.testNextPossibleCell(focusElement)) {
        focusElement = this.splitIdPosition(payload, 'down', i);
      }
      this.moveCursor(focusElement);
    },
    resetGameAction() {
      let diagram = this.diagram;
      _.each(diagram, (row, rowIndex) => {
        _.each(row, (col, colIndex) => {
          this.diagram[rowIndex][colIndex].block = false;
        });
      });
      this.newGame();
      this.resetCheckStatus();
    },
    checkGameAction() {
      var isCorrect = true;
      var isCorrectWord = true;
      let index;
      let self = this;
      this.diagram.forEach(function (item, i) {
        isCorrectWord = true;
        item.forEach(function (obj, j) {
          if (obj.correct != null) {
            index = _.findIndex(obj.correct, (o) => {
              if (self.startGameConfig.caseSensitive) {
                return o === _.trim(obj.val);
              } else {
                return o === _.trim(obj.val.toUpperCase());
              }
            });
            if (index === -1 && !_.isObject(obj.static)) {
              isCorrectWord = isCorrect = false;
            }
          }
        });
        /** @type {String} całe słowo w wierszu */
        let wholeWord = _.compact(
          _.map(item, (cell) => {
            if (cell.correct != null) {
              /** zwraca albo wartośc z inputta (val) albo jeśli jest static PIERWSZĄ!! z listy możliwych odpowiedzi  */
              return _.isObject(cell.static) && cell.correct && cell.correct[0] ? cell.correct[0] : cell.val;
            }
          })
        ).join('');
        let wordTest;
        /** testuje czy cały wyraz jest poprawny (mozliwe odpowiedzi z tablicy pass) */
        if (self.initData[i] && self.initData[i].pass) {
          wordTest = _.findIndex(self.initData[i].pass, (password) => {
            if (self.startGameConfig.caseSensitive) {
              return password === wholeWord;
            } else {
              return password === wholeWord.toUpperCase();
            }
          });
        }
        /** jeśli cały wyraz źle mimo że poszczególne litery OK ustaw na ŹLE */
        if (wordTest === -1) {
          isCorrectWord = isCorrect = false;
          item.forEach(function (obj, j) {
            if (obj.correct != null) {
              self.diagram[i][j].wrong = true;
            }
          });
        }
        if (isCorrectWord) {
          item.forEach(function (obj, j) {
            if (obj.correct != null) {
              self.diagram[i][j].block = true;
            }
          });
        } else {
          item.forEach(function (obj, j) {
            if (obj.correct != null && !obj.pass) {
              self.diagram[i][j].wrong = true;
            }
          });
        }
      });
      if (!isCorrect) {
        setTimeout(this.removeWrong, 1000);
      }
      return isCorrect;
    },
    removeWrong() {
      var self = this;
      self.diagram.forEach(function (x) {
        x.forEach(function (y) {
          if (y.wrong === true) y.wrong = false;
        });
      });
    },
    getStyle(item) {
      return _.merge({}, this.getCustomStyle(item));
    },
    getListPasssStyle(item) {
      return _.merge({}, this.getCustomStyle(item));
    },
    getPasssListStyle(item) {
      if (item && item.listStyle) {
        return _.merge(
          {},
          {
            position:
              this.startGameConfig.passList !== undefined && this.startGameConfig.passList.pos !== undefined
                ? 'absolute'
                : undefined,
            left:
              this.startGameConfig.passList !== undefined &&
              this.startGameConfig.passList.pos !== undefined &&
              Number.isInteger(this.startGameConfig.passList.pos.x)
                ? this.startGameConfig.passList.pos.x + 'px'
                : undefined,
            top:
              this.startGameConfig.passList !== undefined &&
              this.startGameConfig.passList.pos !== undefined &&
              Number.isInteger(this.startGameConfig.passList.pos.y)
                ? startGameConfig.passList.pos.y + 'px'
                : undefined,
          },
          this.getCustomStyle(item.listStyle)
        );
      }
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    isTitle(item) {
      if (item && item.sharedBlock && item.sharedBlock.title) {
        return true;
      }
      return false;
    },
    isWrong(a) {
      return a.wrong == true;
    },
    isGood(a) {
      return a.block === true && a.static !== true && this.initData.showGood !== false;
    },
    isStatic(a) {
      return _.isObject(a.static);
    },
  },
};
</script>
<style lang="scss" scoped>
.game-tr-input {
  background: transparent !important;
}

.game-container {
  display: flex;
  // margin-top:100px;
  // padding-top: 200px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  padding-top: 100px;
  .crossword-overflov-container {
    position: relative;
    top: 43px;
    /* left: 100px; */
    height: 76%;
    width: 100%;
    display: flex;
    justify-content: center;
    /* align-items: baseline; */
    /* flex-direction: column; */
    overflow: auto;
    padding-top: 10px;
    .overflov-element {
      height: 100%;
    }
  }
}

.listPasss {
  display: flex;
  flex-direction: inherit;
  padding-top: 20px;
  position: absolute;
  top: 650px;
  .list-pass-element-container {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}

.passList {
  text-align: left;
  margin-top: 5px;
  overflow: auto;
  height: 100%;
  padding-left: 60px;
}

.game-container table {
  border-collapse: collapse;
  font-weight: bold;
}

.game-container td {
  // border: 1px solid black;
  // box-shadow: inset 0 0 2px 3px black;
  vertical-align: central;
  text-align: center;
}
.game-container td :not(.null) {
  // box-shadow: rgb(56, 56, 56) 0 0 3px 3px;
  box-shadow: rgb(56, 56, 56) 0 0 0 2px;
  vertical-align: central;
  text-align: center;
}

.crossword .num {
  border: none;
  color: red;
  width: 52px;
  font-size: 32px;
  //    padding: 0 25px;
  box-shadow: none !important;
}

.num span {
  box-shadow: none !important;
}

.crossword .null {
  border: none;
}
.crossword .pass {
  background-color: #03a9f4;
}
.answer {
  transition: all 500ms ease 0s;
}
.answerBad:not(.pass) {
  background: rgba(196, 26, 26, 0.1) !important;
}
.answerGood:not(.pass) {
  background-color: rgba(55, 178, 228, 0.45) !important;
}
.crossword .answer.pass {
  background-color: #03a9f4;
}
// .td-answer-static {
//     background-color: #74ff9b;
//
// }
.answerStatic {
  background-color: '#e6e6e6';
  height: 48px;
  width: 49px;
  line-height: 1.2 !important;
}
</style>
